import React, { Suspense } from 'react';
import { Route } from 'react-router';
import {
    cchiItemInfo,
} from '../constants/constants';
import PageLoader from '../components/PageLoader/PageLoader';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';

const NphiesCchiItemInfoPage = React.lazy(() => import('../pages/NphiesCchiPage/NphiesCchiItemInfoPage'));

const NphiesCchiRoutes = props => (
    <GenericSettingContainer {...props} >
        <Suspense fallback={<PageLoader />}>
            <Route path={cchiItemInfo} exact component={NphiesCchiItemInfoPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default NphiesCchiRoutes;
